import { ALLOWED_UPLOAD_MIME_TYPES } from '../utils/acceptUploadFileTypes'

export const allowedUploadTypes = [...ALLOWED_UPLOAD_MIME_TYPES]
